// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer___9aDB","content":"styles_content__hl8iz","checkbox":"styles_checkbox__1DcqY","checkboxLabel":"styles_checkboxLabel__1K3hI"};